import { Link } from "react-router-dom";
import { getMoviesByType, typeLabels } from "@/utils/media";

const entries = [
  {
    type: "movie",
    desc: "院线大片与经典佳作",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20movie%20theater%20with%20rows%20of%20red%20seats%20and%20a%20glowing%20screen%2C%20warm%20amber%20lighting%2C%20editorial%20photography%2C%20inviting%20atmosphere%2C%20no%20text&width=800&height=500&seq=xg-cat-movie&orientation=landscape",
  },
  {
    type: "tv",
    desc: "热播剧集持续更新",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20cozy%20living%20room%20with%20a%20large%20tv%20screen%20glowing%20at%20dusk%2C%20warm%20amber%20and%20cream%20tones%2C%20editorial%20photography%2C%20comfortable%20atmosphere%2C%20no%20text&width=800&height=500&seq=xg-cat-tv&orientation=landscape",
  },
  {
    type: "variety",
    desc: "综艺真人秀轻松追",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20bright%20variety%20show%20stage%20with%20rainbow%20spotlights%20and%20confetti%2C%20vivid%20warm%20yellow%20and%20teal%20tones%2C%20editorial%20photography%2C%20joyful%20energetic%20atmosphere%2C%20no%20text&width=800&height=500&seq=xg-cat-variety&orientation=landscape",
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-8 -mt-10 md:-mt-14 relative z-30">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {entries.map((entry) => {
          const count = getMoviesByType(entry.type).length;
          return (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className="group relative h-32 md:h-36 rounded-lg overflow-hidden bg-foreground-950"
            >
              <img
                src={entry.image}
                alt={`${typeLabels[entry.type]}分类`}
                title={`${typeLabels[entry.type]} - 向日葵视频影视分类`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/30"></div>
              <div className="absolute inset-0 flex items-center justify-between px-5">
                <div>
                  <h3 className="font-heading font-extrabold text-xl md:text-2xl text-background-50 flex items-center gap-2">
                    <i className="ri-bookmark-3-fill text-primary-500 text-lg"></i>
                    {typeLabels[entry.type]}
                  </h3>
                  <p className="mt-1 text-xs md:text-sm text-background-200">{entry.desc}</p>
                  <p className="mt-2 text-xs text-primary-400 font-medium">共 {count} 部作品</p>
                </div>
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-foreground-950 transition-transform group-hover:translate-x-1">
                  <i className="ri-arrow-right-line text-xl"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}